import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import styles from './style.cssmodule.css';
import { ReactComponent as SuccessIcon } from './icons/success.svg';
import { ReactComponent as WarningIcon } from './icons/warning.svg';
import { ReactComponent as AlertIcon } from './icons/alert.svg';
import { ReactComponent as InfoIcon } from './icons/info.svg';
import { ReactComponent as CloseIcon } from './icons/close.svg';

/* eslint-disable */
const getStatusIcon = (messageType) =>  messageType === 'info'    ? <InfoIcon/> :
                                        messageType === 'warning' ? <WarningIcon/> :
                                        messageType === 'alert'   ? <AlertIcon/> :
                                        messageType === 'success' ? <SuccessIcon/> :
                                                                  <InfoIcon/>;
/* eslint-enable */

function Message2({
  type, /* info | success | alert | warning */
  showCloseButton,  /* true | false */
  onClose,
  title,
  children,
}) {
  const [isVisible, setIsVisible] = useState(true);
  const icon = getStatusIcon(type);

  const { formatMessage: t } = useIntl();

  const LeftBorder = () => <div className={styles.leftBorder} />;

  const handleClose = () => {
    onClose();
    setIsVisible(false);
  };

  const CloseButton = (
    <button
      type="button"
      onClick={handleClose}
      className={styles.closeButton}
      aria-label={t({ id: 'button.close' })}
    >
      <CloseIcon />
    </button>
  );

  return (
    isVisible ? (
      <div
        className={styles.message}
        data-type={type}
      >
        <LeftBorder />
        {icon}
        <div>
          <h4 className={styles.messageTitle}>{title}</h4>
          <p className={styles.messageContent}>{children}</p>
        </div>
        {showCloseButton && CloseButton}
      </div>
    ) : null
  );
}

Message2.propTypes = {
  type: PropTypes.string,
  showCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
};

Message2.defaultProps = {
  type: 'info',
  showCloseButton: true,
  onClose: () => {},
  title: 'Title',
  children: null,
};

export default Message2;



// WEBPACK FOOTER //
// ./components/messages/Message2.js